import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { reduxForm, Field, getFormValues } from 'redux-form';

import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import * as Render from './../../../lib/render';
import * as Validator from './../../../lib/validate';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  container: {
    width: '100%',
    padding: '0 12px 0 12px',
  },
  container2: {
    width: '100%',
    padding: '0 12px 0 0',
  },
  header: {
    backgroundColor: '#5dabdb',
    color: '#ffffff',
    textAlign: 'center',
    padding: '20px'
  },
  rows: {
    width: '100%',
    padding: '20px 12px 20px 12px',
    border: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: '#ffffff',
    '&:nth-of-type(odd)': {
      backgroundColor: "#F2F8F7",
    },
  },
  text: {
    fontSize: '10pt',
  },
  title: {
    minWidth: '100px',
    maxWidth: '140px',
  },
  control: {
    textAlign: 'left',
    padding: '20px',
  },
  textField: {
    maxWidth: 300,
    textAlign: 'center',
  },
  textField2: {
    maxWidth: 300,
    textAlign: 'center',
    padding: '0 12px 0 12px',
  },
  checkBox: {
    marginLeft: 40,
  },
  textCenter: {
    textAlign: 'center',
    padding: '20px'
  },
  textCenter2: {
    justifyContent: 'center',
  },
  textField3: {
    width: '100%',
    padding: '0 12px 0 12px',
    textAlign: 'center',
    fontSize: '25pt',
    marginTop: '30px',
  },
  textField4: {
    maxWidth: 150,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    height: "40px",
    fontSize: 15,
    textAlign: 'center',
    lineheight: 2,
  },

  shadow:{
    boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
  }
});

class UpdateComplete extends React.Component {
  state = {
    length: 1,
    getCount: 0
  }
  
  createRow = (idx) => {
    let classes = this.props.classes;
    let keys = {
      personalNumber : "personalNumber_" + idx,
      status : "status_" + idx
    };
    let values = this.props.kojinInfoInList[idx-1];
    
    return (
      <Grid container className={classes.rows} key={idx}>
        <CssBaseline />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.textCenter}>
            <span>
              <span className={this.props.classes.cursor}>
                <input
                  type="text"
                  name={keys.personalNumber}
                  id={keys.personalNumber}
                  className={classes.textField4}
                  disabled={true}
                  value={values.personalNumber}
                  />
              </span>
              <span>
                <input
                  type="text" 
                  name={keys.name} 
                  id={keys.name} 
                  className={classes.textField4}
                  disabled={true}
                  value={values.personalName}
                />
              </span>
            </span>
          </Grid>
          <Grid item xs={6} className={classes.textCenter}>
            <span className={classes.textCenter2}>
              <span className={this.props.classes.cursor}>
                <input
                  type="text"
                  name={keys.status}
                  id={keys.status}
                  className={classes.textField4}
                  disabled={true}
                  value={values.status}
                  />
              </span>
            </span>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  
  render() {
    const { classes } = this.props;

    console.log("this.props.kojinInfoInList", this.props.kojinInfoInList );

    let rows  = [];
    for(var i=1; i<=this.props.kojinInfoInList.length; i++){
      rows.push(this.createRow(i));
    }

    return (
      <div className={classes.root}>
        <CssBaseline />

        <Grid container className={classes.container} spacing={2}>
          <div className={classes.textField3}>更新が完了しました</div>
          <Grid item xs={12}></Grid>
            <Grid item xs={12}>
              <Grid container className={classes.shadow}>
                <Grid item xs={6} className={classes.header}>
                  個人番号・氏名
                </Grid>
                <Grid item xs={6} className={classes.header}>
                  ステータス
                </Grid>
                <Grid item xs={12} id="personalRows">
                  {rows}
                </Grid>
              </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const FORM_NAME = "UpdateComplete";

const mapStateToProps = state => ({
  initialValues:{
  },
  values: getFormValues(FORM_NAME)(state),
  kojinInfoInList: state.infoupd.kojinInfo,
});

const mapDispatchToProps = {
};

UpdateComplete = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(UpdateComplete));

UpdateComplete.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(UpdateComplete));